import { getServiceUrl, httpPost, httpGet } from '../services/api';
import { ParlayUserState } from '../services/parlay-card/parlay-card';
import { BetslipMode, BetSlipUserState } from '../services/sports/types';
import { TicketResponse } from '@staycool/retail-types/ticket';
import { Transaction } from '@staycool/retail-types/transaction';
import { EntrySelections } from '@staycool/contests-types/entry';

const getUrl = (url) => getServiceUrl('retail-proxy', url);

export function saveBringYourDevice({ code, device }: BringYourOwnDeviceData) {
    const url = getUrl(`bring-your-device`);
    return httpPost(url, { code, device });
}

export interface BringYourOwnDeviceData {
    code: string;
    device: {
        betslip?: Record<number, number> | ParlayCardBetslipMarketIdToOutcomeIds;
        userState?: ParlayUserState | BetSlipUserState;
        betslipMode?: BetslipMode;
    };
}

export async function getTicket(id: string) {
    return await httpGet<TicketResponse>(getUrl(`ticket/check/${id}`));
}

export async function getEntry(entryId: string) {
    const url = getUrl(`contest/entry-check/${entryId}`);
    return httpGet<EntryResponse>(url);
}

type ParlayCardBetslipMarketIdToOutcomeIds = Record<number, number[]>;

interface EntryResponse {
    entry: EntrySelections;
    transactions: {
        issued_by?: string;
        issueTransaction: Transaction;
        redeemed_by?: string;
        redeemed_at?: Date;
        redeemed_transaction_id?: string;
        redeemTransaction?: Transaction;
    };
}
